import { useSuspenseQuery } from '@tanstack/react-query';

import { dagKeys } from '@/shared/lib/query/queryKeys';

import { fetchDagOverviewApi } from '@/entities/dag/api';

export const useDagOverview = (dagUuid: string) => {
  return useSuspenseQuery({
    queryKey: dagKeys.dagOverview(dagUuid),
    queryFn: () => fetchDagOverviewApi({ dagUuid }),
    retry: false,
    refetchInterval: 5000,
  });
};
